import React from 'react';
import OutofInternetCard from './outof-internet-card';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Grid, Pagination } from 'swiper';

const OutofInternetSwiper = ({ data, pmsitem }) => {
  return (
    <Swiper
      className="column_swiper_1"
      spaceBetween={6}
      slidesPerView="auto"
      grid={{ cols: 3, fill: 'col' }}
      modules={[Grid, Pagination]}
    >
      {data?.response?.map((item) => {
        return (
          <SwiperSlide className="w-50">
            <OutofInternetCard pmsitem={pmsitem} data={item} />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default OutofInternetSwiper;
